import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PaymentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"payment"}/>
}
